import template from "bundle-text:./index.html";
import { Career } from "./components/career";

let aboutInitialized = false;

const initAbout = () => {
  if (aboutInitialized) return;
  aboutInitialized = true;

  // Inject careers
  var careersContainer = document.querySelector(".career-timeline");
  if (careersContainer) {
    const careerContent = Career();
    var careers = new DOMParser().parseFromString(careerContent, "text/html");
    careersContainer.appendChild(careers.querySelector("ul"));
  }

  // define variables
  var items = document.querySelectorAll(".career-timeline li");

  // check if an element is in viewport
  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function callbackFunc() {
    Array.from(document.getElementsByClassName("experience-years")).forEach(
      (e) => (e.innerHTML = new Date().getFullYear() - 2008),
    );
    for (var i = 0; i < items.length; i++) {
      if (isElementInViewport(items[i])) {
        items[i].classList.add("in-view");
      }
    }
  }

  // listen for events - use passive listeners for better scroll performance
  window.addEventListener("resize", callbackFunc, { passive: true });
  window.addEventListener("scroll", callbackFunc, { passive: true });

  // Initial call
  callbackFunc();
};

// Set up smooth scrolling globally (once)
const setupSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
};

export const About = () => {
  // Use requestIdleCallback for non-critical initialization
  if ("requestIdleCallback" in window) {
    requestIdleCallback(() => {
      initAbout();
      setupSmoothScroll();
    });
  } else {
    setTimeout(() => {
      initAbout();
      setupSmoothScroll();
    }, 0);
  }

  return template;
};

export default About;
